import _defineProperty from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _asyncToGenerator from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "/home/node/app/node_modules/next/node_modules/@babel/runtime/regenerator";
/** @format */

import initApollo from "../data/apollo";
import gql from 'graphql-tag';
import Cookies from 'universal-cookie';
import { v4 as uuidv4 } from 'uuid';
import { Buffer } from 'buffer';
import { MARKETING_EMAIL_CODE, MARKETING_EMAIL_COOKIE_NAME, RED_PLANET_COOKIE_NAME, NEW_USER_OPT_OUT_COOKIE_NAME, LSL_TOKEN_NAME, LSL_SESSION_TOKEN_NAME } from "../constants/app";
import TrackingUtilities from "../utils/trackingUtilities";
import { gtagEvent } from "../utils/gtag";
import config from "../utils/clientConfig";
import { getShoSessionTokens, removeShoSessionTokens, createShoSession, getShoSessionData, refreshShoSession } from "../utils/sessionHelper";
import { getLoginSlugFromSessionStorage, setLoginSlugToSessionStorage } from "../utils/sessionStorageHelper";
import { invalidateAccessToken } from "../services/invalidateAccessToken";
import { getLslAccessTokenFromCookie, removeOAuthUserInfo } from "../utils/loginHelper";
import { fetchClickUrl, clearShopMerchant } from "./shop";
import { queries } from "../data/queries";
var cookies = new Cookies();
var initialState = {
  authorized: false,
  authenticated: false,
  lslSession: false,
  firstName: '',
  enrolled: false,
  showLoginModal: false,
  frequentFlyerInfo: {},
  pendingCards: 0,
  favourites: {},
  showOptIn: false,
  showNewUserModal: false,
  bonusFavourites: [],
  memberDetailsSynced: false,
  memberDetailsSyncInProgress: false
};
export var actionTypes = {
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGOUT: 'LOGOUT',
  OPEN_LOGIN_MODAL: 'OPEN_LOGIN_MODAL',
  CLOSE_LOGIN_MODAL: 'CLOSE_LOGIN_MODAL',
  SYNC_MEMBER_DETAILS_SUCCESS: 'SYNC_MEMBER_DETAILS_SUCCESS',
  EXPIRE_LSL_SESSION: 'EXPIRE_LSL_SESSION',
  EXPIRE_SHO_SESSION: 'EXPIRE_SHO_SESSION',
  TOGGLE_FAVOURITE: 'TOGGLE_FAVOURITE',
  OPEN_OPTIN_MODAL: 'OPEN_OPTIN_MODAL',
  CLOSE_OPTIN_MODAL: 'CLOSE_OPTIN_MODAL',
  OPEN_NEW_USER_MODAL: 'OPEN_NEW_USER_MODAL',
  CLOSE_NEW_USER_MODAL: 'CLOSE_NEW_USER_MODAL',
  TOGGLE_POINTSPROMPTER: 'TOGGLE_POINTSPROMPTER',
  UNLINK_CARD: 'UNLINK_CARD',
  BEGIN_MEMBER_DETAILS_SYNC: 'BEGIN_MEMBER_DETAILS_SYNC'
};
var CLIENT_ID = 'QantasShopping';
var getOauthRedirectUri = function getOauthRedirectUri() {
  return "".concat(window.location.origin, "/auth-callback");
};
export var base64URLDecodeObject = function base64URLDecodeObject(base64URLString) {
  var base64String = base64URLString.replace(/-/g, '+').replace(/_/g, '/');
  var buffer = Buffer.from(base64String, 'base64').toString('utf8');
  return JSON.parse(buffer);
};
var base64URLEncode = function base64URLEncode(buffer) {
  return buffer.toString('base64').replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
};
export var base64EncodeStateObject = function base64EncodeStateObject(state) {
  return base64URLEncode(Buffer.from(JSON.stringify(state)));
};
export var appendOriginUrl = function appendOriginUrl(uri) {
  return uri.includes('http') ? uri : "".concat(window.location.origin).concat(uri || '');
};
export var redirectToGivenUri = function redirectToGivenUri(uri) {
  window.location.replace(appendOriginUrl(uri));
};
export var redirectToOauthLoginPage = function redirectToOauthLoginPage() {
  var redirectURL = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var enforceLogin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var uuid = uuidv4();
  var redirectUri = redirectURL && typeof redirectURL === 'string' ? redirectURL : window.location.origin;
  var state = {
    uuid: uuid,
    redirectUri: redirectUri
  };
  var oauthState = base64EncodeStateObject(state);
  var oauthUrl = new URL("".concat(config.OAUTH_LOGIN_URL, "/oauth"));
  window.sessionStorage.setItem('oauth_session_state', oauthState);
  window.sessionStorage.setItem('oauth_request_triggered_by', window.location.pathname);
  oauthUrl.searchParams.append('response_type', 'code');
  oauthUrl.searchParams.append('client_id', CLIENT_ID);
  oauthUrl.searchParams.append('scope', 'profile');
  oauthUrl.searchParams.append('state', oauthState);
  oauthUrl.searchParams.append('redirect_uri', getOauthRedirectUri());
  // we want cancel button on login screen
  oauthUrl.searchParams.append('cancel', 'true');
  oauthUrl.searchParams.append('web', 'true');
  if (!enforceLogin) {
    oauthUrl.searchParams.append('prompt', 'none');
  }
  window.location.href = oauthUrl.toString();
};
export var openLoginModal = function openLoginModal() {
  var redirectURL = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return function (dispatch) {
    dispatch({
      type: actionTypes.OPEN_LOGIN_MODAL
    });
    redirectToOauthLoginPage(redirectURL);
  };
};
export var closeLoginModal = function closeLoginModal() {
  return function (dispatch) {
    dispatch(clearShopMerchant());
    dispatch({
      type: actionTypes.CLOSE_LOGIN_MODAL
    });
  };
};
export var logoutFromLsl = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var accessToken;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            accessToken = getLslAccessTokenFromCookie();
            if (!accessToken) {
              _context.next = 4;
              break;
            }
            _context.next = 4;
            return invalidateAccessToken(accessToken, config.QUERY_API_BASE);
          case 4:
            _context.prev = 4;
            _context.next = 7;
            return fetch("".concat(config.OAUTH_LOGIN_URL, "/logoff"), {
              method: 'GET',
              credentials: 'include',
              headers: {
                'Content-Type': 'application/json'
              }
            });
          case 7:
            _context.next = 12;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](4);
            console.error('Error in logoff call', _context.t0);
          case 12:
            cookies.remove(LSL_SESSION_TOKEN_NAME, {
              path: '/',
              domain: '.qantas.com'
            });
          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 9]]);
  }));
  return function logoutFromLsl() {
    return _ref.apply(this, arguments);
  };
}();
export var logout = function logout() {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return logoutFromLsl();
            case 2:
              cookies.remove(LSL_TOKEN_NAME, {
                path: '/'
              });
              cookies.remove(RED_PLANET_COOKIE_NAME, {
                path: '/'
              });
              removeOAuthUserInfo();
              removeShoSessionTokens();
              TrackingUtilities.trackLogout();
              dispatch({
                type: actionTypes.LOGOUT
              });
              if (window.location.pathname !== '/') {
                setTimeout(function () {
                  window.location.href = '/';
                }, 1000);
              }
            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var logoutViaExpire = function logoutViaExpire() {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch) {
      var _window;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              (_window = window) === null || _window === void 0 ? void 0 : _window.sessionStorage.removeItem('accessTokenExpiry');
              removeOAuthUserInfo();
              window.sessionStorage.removeItem('oauth_session_state');
              cookies.remove(RED_PLANET_COOKIE_NAME, {
                path: '/'
              });
              dispatch({
                type: actionTypes.EXPIRE_LSL_SESSION
              });
            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export var expireLslSession = function expireLslSession() {
  return {
    type: actionTypes.EXPIRE_LSL_SESSION
  };
};
export var expireShoSession = function expireShoSession() {
  return {
    type: actionTypes.EXPIRE_SHO_SESSION
  };
};
var newUserOptOutCookie = cookies.get(NEW_USER_OPT_OUT_COOKIE_NAME);
var isNewUserModalSetToOpen = function isNewUserModalSetToOpen(newUser) {
  return newUser || newUser === null && newUserOptOutCookie === undefined;
};
var newUserModalShouldNotBeShown = function newUserModalShouldNotBeShown(newUser) {
  return newUser === false || newUser === null && newUserOptOutCookie;
};
export var openOptInModal = function openOptInModal() {
  return function (dispatch, getState) {
    var _getState = getState(),
      _getState$user = _getState.user,
      frequentFlyerInfo = _getState$user.frequentFlyerInfo,
      authorized = _getState$user.authorized,
      authenticated = _getState$user.authenticated,
      newUser = _getState$user.newUser;

    // do not show opt in if ff info not present
    if (!(frequentFlyerInfo !== null && frequentFlyerInfo !== void 0 && frequentFlyerInfo.preferences)) {
      return;
    }

    // do not show opt in if new user modal will be open
    if (isNewUserModalSetToOpen(newUser)) {
      return;
    }
    var emailCodes = frequentFlyerInfo.preferences.emailCodes;
    var isEmailCodeSet = emailCodes === null || emailCodes === void 0 ? void 0 : emailCodes.includes(MARKETING_EMAIL_CODE);

    // do not show opt in if already opt in
    if (isEmailCodeSet) {
      return;
    }
    if ((authorized || authenticated) && !cookies.get(MARKETING_EMAIL_COOKIE_NAME)) {
      dispatch({
        type: actionTypes.OPEN_OPTIN_MODAL
      });
    }
  };
};
export var closeOptInModal = function closeOptInModal() {
  return function (dispatch) {
    dispatch({
      type: actionTypes.CLOSE_OPTIN_MODAL
    });
  };
};
export var openNewUserModal = function openNewUserModal() {
  return function (dispatch, getState) {
    var _getState2 = getState(),
      _getState2$user = _getState2.user,
      newUser = _getState2$user.newUser,
      authorized = _getState2$user.authorized,
      authenticated = _getState2$user.authenticated;
    if (newUserModalShouldNotBeShown(newUser)) {
      return;
    }
    if ((authorized || authenticated) && isNewUserModalSetToOpen(newUser)) {
      dispatch({
        type: actionTypes.OPEN_NEW_USER_MODAL
      });
    }
  };
};
export var closeNewUserModal = function closeNewUserModal() {
  return function (dispatch) {
    dispatch({
      type: actionTypes.CLOSE_NEW_USER_MODAL
    });
  };
};
export var syncMemberDetails = function syncMemberDetails() {
  return function (dispatch, getState) {
    var _getState3 = getState(),
      authenticated = _getState3.user.authenticated;
    var apollo = initApollo();
    var authenticatedFields = "\n    cards {\n      accountStatus,\n      maskedPAN\n    },\n    pendingCards,\n    frequentFlyerInfo {\n      email,\n      gender,\n      tier {\n        effectiveTierName,\n        effectiveTier\n      },\n      preferences {\n        emailCodes\n      }\n    }\n    trackingInfo {\n      token\n    }\n  ";
    dispatch({
      type: actionTypes.BEGIN_MEMBER_DETAILS_SYNC
    });
    return apollo.query({
      query: gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        query getMemberDetails {\n          memberDetails {\n            programStatus,\n            offerCount,\n            activatedOfferTypes,\n            locationLimitedMerchants,\n            earnedPoints,\n            newUser,\n            ", "\n          }\n          favouriteMerchants: myFavouritesMerchants {\n            merchantId\n            is_elevated\n            rebate{\n              rebate_user\n              start_date\n              end_date\n            }\n          }\n        }\n      "])), authenticated ? authenticatedFields : ''),
      fetchPolicy: 'network-only'
    }).then(function (_ref4) {
      var _ref4$data = _ref4.data,
        memberDetails = _ref4$data.memberDetails,
        favouriteMerchants = _ref4$data.favouriteMerchants;
      var favourites = {};
      var bonusFavourites = [];
      favouriteMerchants.forEach(function (f) {
        favourites[f.merchantId] = true;
        if (f.is_elevated) {
          bonusFavourites.push(f.merchantId);
        }
      });
      dispatch({
        type: actionTypes.SYNC_MEMBER_DETAILS_SUCCESS,
        user: _objectSpread(_objectSpread({}, memberDetails), {}, {
          favourites: favourites,
          bonusFavourites: bonusFavourites,
          enrolled: memberDetails.programStatus && memberDetails.programStatus === 'OPTED_IN'
        })
      });
      return memberDetails;
    });
  };
};
export var syncShoSession = function syncShoSession() {
  return function (dispatch) {
    var _getShoSessionTokens = getShoSessionTokens(),
      accessToken = _getShoSessionTokens.accessToken,
      refreshToken = _getShoSessionTokens.refreshToken;
    if (!accessToken && !refreshToken) {
      dispatch(expireShoSession());
    }
  };
};
export var setUserAuthenticatedOnRefresh = function setUserAuthenticatedOnRefresh(loginDetails) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              // Update state with member info from login widget
              dispatch({
                type: actionTypes.LOGIN_SUCCESS,
                user: _objectSpread(_objectSpread({}, loginDetails), {}, {
                  authenticated: true,
                  authorized: true
                })
              });
            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return function (_x3) {
      return _ref5.apply(this, arguments);
    };
  }();
};
export var loginSuccess = function loginSuccess(loginDetails) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dispatch, getState) {
      var _window2;
      var _getState4, authenticated, session, memberDetails, trackingInfo, accessTokenExpiry, _getState5, merchant, loginSlug;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _getState4 = getState(), authenticated = _getState4.user.authenticated; // Don't re-fetch data or start an app session again if already authenticated
              if (!authenticated) {
                _context5.next = 3;
                break;
              }
              return _context5.abrupt("return");
            case 3:
              if (!cookies.get(LSL_TOKEN_NAME)) {
                _context5.next = 9;
                break;
              }
              removeShoSessionTokens();
              _context5.next = 7;
              return createShoSession(loginDetails.accessToken, loginDetails.firstName);
            case 7:
              _context5.next = 12;
              break;
            case 9:
              if (!(!getShoSessionData() && loginDetails.accessToken)) {
                _context5.next = 12;
                break;
              }
              _context5.next = 12;
              return createShoSession(loginDetails.accessToken, loginDetails.firstName);
            case 12:
              // Call to get a new access token if the sho access token has expired;
              // It prevent the getMemberDetails from getting back Error "Access token expired"
              session = getShoSessionData();
              if (!(session && Date.now() > session.exp * 1000)) {
                _context5.next = 16;
                break;
              }
              _context5.next = 16;
              return refreshShoSession();
            case 16:
              // Update state with member info from login widget
              dispatch({
                type: actionTypes.LOGIN_SUCCESS,
                user: _objectSpread(_objectSpread({}, loginDetails), {}, {
                  authenticated: true,
                  authorized: true
                })
              });

              // Syncing additional details about member from MCO dynamo and IFly
              _context5.next = 19;
              return dispatch(syncMemberDetails());
            case 19:
              memberDetails = _context5.sent;
              // Set Red Planet tracking cookie
              trackingInfo = memberDetails.trackingInfo;
              if (trackingInfo !== null && trackingInfo !== void 0 && trackingInfo.token) {
                TrackingUtilities.trackLogin(trackingInfo.token);
                cookies.set(RED_PLANET_COOKIE_NAME, trackingInfo.token, {
                  path: '/'
                });
                gtagEvent({
                  action: 'conversion',
                  tag: config.GTAG.enrolment,
                  value: 'qmall/qfflogin+standard'
                });
              }

              // Set the expiry time for the access token in session storage so automatic bump to soft login can happen
              accessTokenExpiry = Date.now() + loginDetails.expiresIn * 1000;
              (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.sessionStorage.setItem('accessTokenExpiry', accessTokenExpiry.toString());

              // Redirect on login if user has intended to shop beforehand
              _getState5 = getState(), merchant = _getState5.shop.merchant;
              if (merchant) {
                dispatch(fetchClickUrl(merchant.merchantIdOLM, merchant.fromPlugin));
              }
              loginSlug = getLoginSlugFromSessionStorage();
              if (!(loginSlug && (loginSlug.slug || loginSlug.fromPlugin))) {
                _context5.next = 31;
                break;
              }
              setLoginSlugToSessionStorage(null);
              window.location.replace("".concat(window.location.origin, "/login-success-page?slug=").concat(loginSlug.slug.replace(/\+/g, '%2B'), "&fromPlugin=").concat(loginSlug.fromPlugin));
              return _context5.abrupt("return");
            case 31:
              // Redirect on login if redirect URL is set
              if (loginDetails.redirectUri) {
                // test if redirectUri is absolute or relative
                redirectToGivenUri(loginDetails.redirectUri);
              }
            case 32:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
    return function (_x4, _x5) {
      return _ref6.apply(this, arguments);
    };
  }();
};
export var updateMemberPreferences = function updateMemberPreferences(emailCode) {
  return function (dispatch) {
    var apollo = initApollo();
    return apollo.mutate({
      mutation: gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        mutation updateMemberDetails($emailCode: String) {\n          updateMemberDetails(emailCode: $emailCode) {\n            preferences {\n              emailCodes\n            }\n          }\n        }\n      "]))),
      variables: {
        emailCode: emailCode
      }
    }).then(function () {
      return dispatch(syncMemberDetails());
    });
  };
};
export var resetMemberLastInteractedTimestamp = function resetMemberLastInteractedTimestamp() {
  return function (dispatch) {
    var apollo = initApollo();
    return apollo.mutate({
      mutation: queries.resetLastInteractedTimestamp
    });
  };
};
export var enrolMember = function enrolMember(cardType) {
  return function (dispatch) {
    var apollo = initApollo();
    return apollo.mutate({
      mutation: gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        mutation enrolMember($cardType: String) {\n          enrolmentResult: enrolMember(cardType: $cardType) {\n            enrolled\n            pendingCards\n            firstEnrolment\n            assignedOffers {\n              offerType\n              offerIdMls\n              merchantId\n              merchantName\n              merchantLogoURL\n              headline\n              longDescription\n              offerImageURL\n              redemptionType\n              discount\n              discountType\n              minTransactionAmountToRedeem\n              pointsConversionRate\n              earnRate\n              eventStartDate\n              eventEndDate\n              activated\n              merchantStoreLocatorURL\n              merchantWebsiteURL\n              createdAt\n            }\n          }\n        }\n      "]))),
      variables: {
        cardType: cardType
      }
    }).then(function (_ref7) {
      var enrolmentResult = _ref7.data.enrolmentResult;
      dispatch(syncMemberDetails());
      return enrolmentResult;
    });
  };
};
export var toggleFavourite = function toggleFavourite(merchantId) {
  return function (dispatch) {
    var apollo = initApollo();
    return apollo.mutate({
      mutation: gql(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        mutation toggleFavourite($merchantId: String!) {\n          favouriteResult: toggleFavourite(merchantId: $merchantId) {\n            added\n          }\n        }\n      "]))),
      variables: {
        merchantId: merchantId
      }
    }).then(function (_ref8) {
      var favouriteResult = _ref8.data.favouriteResult;
      dispatch({
        type: actionTypes.TOGGLE_FAVOURITE,
        favourite: _defineProperty({}, merchantId, favouriteResult.added)
      });
      dispatch(syncMemberDetails());
      return favouriteResult;
    });
  };
};
export var togglePointsPrompter = function togglePointsPrompter() {
  return function (dispatch) {
    var apollo = initApollo();
    var pointsPrompter = true;
    return apollo.mutate({
      mutation: gql(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        mutation togglePointsPrompter($pointsPrompter: Boolean!) {\n          PointsPrompterResult: togglePointsPrompter(pointsPrompter: $pointsPrompter) {\n            pointsPrompter\n          }\n        }\n      "]))),
      variables: {
        pointsPrompter: pointsPrompter
      }
    }).then(function (_ref9) {
      var data = _ref9.data;
      var PointsPrompterResult = data.PointsPrompterResult;
      dispatch({
        type: actionTypes.TOGGLE_POINTSPROMPTER,
        pointsPrompter: PointsPrompterResult.pointsPrompter
      });
      return PointsPrompterResult;
    });
  };
};
export var unlinkCardAction = function unlinkCardAction(maskedPAN) {
  return function (dispatch) {
    dispatch({
      type: actionTypes.UNLINK_CARD,
      maskedPAN: maskedPAN
    });
  };
};
export var userReducer = function userReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case actionTypes.BEGIN_MEMBER_DETAILS_SYNC:
      return _objectSpread(_objectSpread({}, state), {}, {
        memberDetailsSyncInProgress: true
      });
    case actionTypes.TOGGLE_FAVOURITE:
      return _objectSpread(_objectSpread({}, state), {}, {
        favourites: _objectSpread(_objectSpread({}, state.favourites), action.favourite)
      });
    case actionTypes.EXPIRE_SHO_SESSION:
      return _objectSpread(_objectSpread({}, initialState), {}, {
        showLoginModal: state.showLoginModal
      });
    case actionTypes.EXPIRE_LSL_SESSION:
      return _objectSpread(_objectSpread({}, state), {}, {
        authenticated: false,
        lslSession: false,
        accessToken: null
      });
    case actionTypes.SYNC_MEMBER_DETAILS_SUCCESS:
      return _objectSpread(_objectSpread(_objectSpread({}, state), action.user), {}, {
        memberDetailsSynced: true,
        memberDetailsSyncInProgress: false
      });
    case actionTypes.OPEN_LOGIN_MODAL:
      return _objectSpread(_objectSpread({}, state), {}, {
        showLoginModal: true
      });
    case actionTypes.CLOSE_LOGIN_MODAL:
      return _objectSpread(_objectSpread({}, state), {}, {
        showLoginModal: false
      });
    case actionTypes.LOGIN_SUCCESS:
      return _objectSpread(_objectSpread(_objectSpread({}, state), action.user), {}, {
        showLoginModal: false
      });
    case actionTypes.LOGOUT:
      return initialState;
    case actionTypes.OPEN_OPTIN_MODAL:
      return _objectSpread(_objectSpread({}, state), {}, {
        showOptIn: true
      });
    case actionTypes.CLOSE_OPTIN_MODAL:
      return _objectSpread(_objectSpread({}, state), {}, {
        showOptIn: false
      });
    case actionTypes.OPEN_NEW_USER_MODAL:
      return _objectSpread(_objectSpread({}, state), {}, {
        showNewUserModal: true
      });
    case actionTypes.CLOSE_NEW_USER_MODAL:
      return _objectSpread(_objectSpread({}, state), {}, {
        showNewUserModal: false
      });
    case actionTypes.TOGGLE_POINTSPROMPTER:
      return _objectSpread(_objectSpread({}, state), {}, {
        pointsPrompter: action.pointsPrompter
      });
    case actionTypes.UNLINK_CARD:
      return _objectSpread(_objectSpread({}, state), {}, {
        cards: state.cards.filter(function (card) {
          return card.maskedPAN !== action.maskedPAN;
        })
      });
    default:
      return state;
  }
};